{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "L'extensió de Chrome no està instal·lada.",
      "CTA": "Instal·la l'extensió"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Sense connexió amb el sistema telefònic",
      "MESSAGE": "Sembla que la teva connexió a internet no funciona. Comprova-la i torna-ho a provar.",
      "CREDENTIALS_TITLE": "El sistema telefònic ha rebutjat les teves credencials",
      "CREDENTIALS_MESSAGE": "El sistema telefònic ha rebutjat el nom d'usuari o la contrasenya desats al teu perfil. Comprova'ls a Configuració del Perfil, o demana-ho al teu administrador.",
      "CONFIGURATION_TITLE": "La configuració del telèfon no és vàlida",
      "CONFIGURATION_MESSAGE": "El nom d'usuari SIP o l'adreça del servidor no tenen un format vàlid, de manera que el telèfon no es pot connectar. Corregeix-ho a Configuració del Perfil.",
      "NETWORK_SHORT": "Connexió fallida",
      "CREDENTIALS_SHORT": "Credencials rebutjades",
      "CONFIGURATION_SHORT": "Configuració no vàlida",
      "RETRY": "Torna-ho a provar",
      "DISMISS": "Cancel·la"
    },
    "CONNECTION_QUALITY": "Qualitat de la connexió",
    "CONNECTION_QUALITY_EXCELLENT": "Excel·lent",
    "CONNECTION_QUALITY_GOOD": "Bona",
    "CONNECTION_QUALITY_FAIR": "Acceptable",
    "CONNECTION_QUALITY_POOR": "Dolenta",
    "CONNECTION_QUALITY_DISCONNECTED": "Desconnectada",
    "TABS": {
      "PHONE": "Telèfon",
      "SMS": "SMS",
      "HISTORY": "Historial"
    },
    "HISTORY": {
      "OPEN": "Obrir",
      "RECENT": "Recents",
      "MISSED": "Perdudes",
      "LOADING": "Carregant trucades...",
      "EMPTY": "Cap trucada aquí",
      "ERROR": "No s'han pogut carregar les trucades",
      "CALL": "Torna a trucar",
      "CALL_STATUS": {
        "BUTTON": "Estableix l'estat de la trucada",
        "TITLE": "Estat de la trucada",
        "SEARCH_PLACEHOLDER": "Cerca estats...",
        "LOADING": "Carregant estats...",
        "NO_OPTIONS": "No hi ha cap estat de trucada configurat",
        "NO_MATCH": "Cap estat coincideix",
        "OPTIONS_ERROR": "No s'han pogut carregar els estats",
        "RETRY": "Torna-ho a provar",
        "CONFIRM_QUESTION": "Establir «{status}» i resoldre la conversa?",
        "CONFIRM": "Confirma",
        "BACK": "Enrere",
        "CANCEL": "Cancel·la",
        "SAVING": "S'està desant...",
        "SAVE_ERROR": "No s'ha pogut desar l'estat",
        "RESOLVE_ERROR": "S'ha desat l'estat, però no s'ha pogut resoldre la conversa"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Número de telèfon, p. ex. +421903000000",
      "BODY_PLACEHOLDER": "Escriviu el vostre missatge...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Envia un SMS",
      "SENDING": "S'està enviant...",
      "SENT": "SMS enviat",
      "LOADING": "S'estan carregant les safates d'entrada d'SMS...",
      "NO_INBOX": "Aquest compte no té cap safata d'entrada d'SMS, per la qual cosa no es pot enviar l'SMS.",
      "INVALID_NUMBER": "Introduïu el número en format internacional, inclòs el + inicial.",
      "ERROR": "No s'ha pogut enviar l'SMS. Torneu-ho a provar."
    },
    "ACTIONS": {
      "CONNECT": "Connecta",
      "GO_TO_TAB": "Vés a aquesta pestanya",
      "DISCONNECT": "Desconnecta",
      "ANSWER": "Respon",
      "HANGUP": "Penja",
      "HOLD": "Posa en espera",
      "MUTE": "Silencia el micròfon",
      "SILENCE": "Silencia l'àudio",
      "TRANSFER": "Transfereix",
      "COMPLETE_TRANSFER": "Completa la transferència",
      "RETURN_TO_CALLER": "Torna a qui truca",
      "CANCEL_TRANSFER": "Cancel·la la transferència",
      "DIALPAD": "Mostra el teclat de marcatge",
      "OPEN_CONVERSATION": "Obre la conversa"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Trucada entrant",
      "INCOMING_CALL_FROM": "Trucada entrant de {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Trucada entrant de {number}",
      "ANSWER": "Respon",
      "DECLINE": "Rebutja"
    },
    "TRANSFER": {
      "TITLE": "Transferir trucada",
      "PLACEHOLDER": "Introduïu el número de destinació...",
      "SEARCH_PLACEHOLDER": "Cerca agents...",
      "TARGET_PLACEHOLDER": "Destinació de la transferència seleccionada",
      "CONFIRM": "Transfereix",
      "MODE_DIRECT": "Transfereix ara",
      "MODE_CONSULT": "Truca primer a l'agent",
      "CANCEL": "Cancel·la"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Segur que vols posar-te en pausa a totes les cues?",
      "CONFIRM_READY": "Segur que vols tornar a l'estat de disponible a totes les cues?",
      "CONFIRM_BREAK_QUEUE": "Segur que vols sortir de la cua {queue}?",
      "CONFIRM_READY_QUEUE": "Segur que vols entrar a la cua {queue}?",
      "LOGIN_TO_QUEUE": "Entra",
      "LOGOUT_FROM_QUEUE": "Surt",
      "LOGIN_TO_ALL_QUEUES": "Entra a totes les cues",
      "LOGOUT_FROM_ALL_QUEUES": "Surt de totes les cues",
      "OPTION_LOGOUT": "Surt",
      "OPTION_BREAK": "Pausa",
      "OPTION_LUNCH": "Dinar",
      "OPTION_AWAY": "Absent",
      "OPTION_DO_NOT_DISTURB": "No molesteu",
      "OPTION_BUSINESS_TRIP": "Viatge de negocis",
      "CONFIRM": "Confirma",
      "CANCEL": "Cancel·la"
    },
    "STATUS": {
      "OFFLINE": "Telèfon fora de línia",
      "IN_OTHER_TAB": "Telèfon connectat en una altra pestanya",
      "CONNECTING": "Connectant...",
      "DISCONNECTING": "Desconnectant...",
      "ONLINE": "Telèfon en línia",
      "DIALING": "Trucant",
      "TRANSFERRING": "Transferint...",
      "CONSULTING": "Parlant amb l'agent",
      "CALLER_ON_HOLD": "La persona que truca està en espera",
      "BUSY": "Ocupat",
      "DND": "DND",
      "UNAVAILABLE": "No disponible",
      "REJECTED": "Trucada rebutjada",
      "CALL_FAILED": "La trucada ha fallat"
    },
    "QUEUES": {
      "MORE": "Més cues"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "Trucant a {number}… Podeu tancar aquesta pestanya.",
    "NO_NUMBER": "No s'ha indicat cap número. Utilitzeu ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Introduïu el número de telèfon...",
    "ACTIONS": {
      "DIAL": "Truca al número",
      "DIAL_FROM": "Tria el número des del qual truques"
    },
    "DIAL_FROM": {
      "TITLE": "Truca des del número d'una safata d'entrada"
    },
    "VALIDATION": {
      "REQUIRED": "El número de telèfon és obligatori",
      "INVALID_FORMAT": "El format del número de telèfon no és vàlid"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Configuració i prova d'àudio",
    "SELECT_DEVICE": "Selecciona un dispositiu...",
    "SYSTEM_DEFAULT": "Predeterminat del sistema",
    "SAVED": "Desat",
    "DISCONNECTED_SUFFIX": "no connectat",
    "DEVICE_DISCONNECTED": "El dispositiu seleccionat no està connectat. Les trucades utilitzaran el predeterminat del sistema fins que torni a estar disponible.",
    "MICROPHONE": {
      "TITLE": "Micròfon",
      "START_TEST": "Prova el micròfon",
      "STOP_TEST": "Atura la prova",
      "LEVEL": "Nivell:",
      "VERDICT": {
        "LISTENING": "Digues alguna cosa al micròfon…",
        "SILENT": "No se't sent. Comprova que el micròfon estigui activat i que s'hagi seleccionat el correcte.",
        "LOW": "Només se't sent fluix. Tria un altre micròfon o ajusta el volum d'entrada a la configuració del sistema.",
        "GOOD": "Bon so — se't sent bé."
      }
    },
    "SPEAKER": {
      "TITLE": "Altaveu",
      "TEST": "Prova l'altaveu",
      "TESTING": "Provant...",
      "VOLUME": "Volum:",
      "USING_DEFAULT": "La sortida seleccionada no està disponible — s'ha reproduït amb el predeterminat del sistema."
    },
    "DONE": "Fet",
    "ERRORS": {
      "MICROPHONE_ACCESS": "S'ha produït un error en accedir al micròfon. Comprova els permisos.",
      "MICROPHONE_PERMISSION_DENIED": "L'accés al micròfon està bloquejat. Permet-lo a la configuració del lloc del navegador per utilitzar el telèfon.",
      "MICROPHONE_SILENT": "El micròfon no capta cap so. Comprova la configuració d'àudio.",
      "EXTENSION_REQUIRED": "No s'ha detectat l'extensió del telèfon. Instal·la-la o activa-la per utilitzar el micròfon.",
      "SPEAKER_TEST": "S'ha produït un error en provar la sortida de l'altaveu."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Fora de línia",
    "ONLINE": "En línia",
    "BUSY": "Ocupat"
  },
  "QUEUE_STATUS": {
    "READY": "Disponible",
    "NOT_READY": "No accepta trucades",
    "WRAP_UP": "Tancament",
    "BREAK": "Pausa",
    "LUNCH": "Dinar",
    "AWAY": "Absent",
    "DO_NOT_DISTURB": "No molesteu",
    "BUSINESS_TRIP": "Viatge de negocis",
    "OTHER_CALL": "Altra trucada",
    "QUEUE_CALL": "Trucada de cua",
    "OFFLINE": "Fora de línia",
    "ONLINE": "En línia",
    "NO_ACCESS": "Sense telèfon",
    "PARTIALLY_READY": "Parcialment disponible",
    "MIXED": "Mixt",
    "CHAT_ONLINE": "En línia (xat)",
    "CHAT_BUSY": "Ocupat (xat)",
    "CHAT_OFFLINE": "Fora de línia (xat)"
  }
}
